module.exports = __webpack_public_path__ + "static/media/brazil-eco.b5b004ec.jpg";